import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes from "model";

export default function CaptureSECDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "secCodeSelectIsActive", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}